import React, { Suspense } from "react";
import { Canvas } from "@react-three/fiber";
import SphereOfSpheres from "./SphereOfSpheres";

const ORANGE = "#F27E33";
const NAVY = "#1D2946";
const BASE_BG = "#0B1620";

export default function GlobalSphereBackground() {
    return (
        <div className="fixed inset-0 z-0 pointer-events-none">
            <Suspense fallback={null}>
                <Canvas
                    eventSource={document.body}
                    eventPrefix="client"
                    camera={{ position: [0, 0, 20], fov: 15 }} // Cámara más alejada para verla bien
                    gl={{ alpha: true, antialias: true }}
                    style={{ background: "transparent" }}
                >
                    {/* Niebla para profundidad */}
                    <fog attach="fog" args={[BASE_BG, 10, 40]} />

                    <SphereOfSpheres
                        count={1200}
                        radius={3.5}       // Un poco más grande
                        pulseAmp={0.32}
                        autoRotate={0.08}  // Rotación suave
                        mouseIntensity={0.5}
                        position={[0, 0, 0]} // Centrada globalmente (o desplazada si se prefiere)
                        baseInnerColor={NAVY}
                        baseOuterColor={ORANGE}
                        explodeFactor={2.5}
                        explodeHardCap={30}
                    />
                </Canvas>
            </Suspense>
        </div>
    );
}
